import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchKeyContactsDone = (_, { payload }) => {
  return [
    ...payload,
  ];
};


const clearKeyContactsDone = () => {
    return initialState;
}

  const initialState = [];

export default createReducer(initialState, {
    [TYPES.FETCH_KEY_CONTACTS_DONE]: fetchKeyContactsDone,
    [TYPES.CLEAR_KEY_CONTACTS_DONE]: clearKeyContactsDone
});

